export const START_COUNTDOWN = "START_COUNTDOWN";
export const UPDATE_TIME = "UPDATE_TIME";
